<template>
  <section class="page-header">
    <div class="page-header-content">
      <div>
        <span v-if="eyebrow" class="page-eyebrow">
          {{ eyebrow }}
        </span>

        <h1>{{ title }}</h1>

        <p v-if="description">
          {{ description }}
        </p>
      </div>

      <div v-if="$slots.actions" class="page-actions">
        <slot name="actions" />
      </div>
    </div>

    <div v-if="$slots.metrics" class="page-metrics">
      <slot name="metrics" />
    </div>
  </section>
</template>

<script setup>
defineProps({
  eyebrow: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: "",
  },
});
</script>

<style scoped>
.page-header {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(214, 222, 234, 0.95);
  border-radius: 28px;
  padding: 1.35rem;
  background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.94),
      rgba(248, 250, 252, 0.82)
    ),
    radial-gradient(
      circle at top right,
      rgba(255, 122, 0, 0.14),
      transparent 24rem
    );
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.08),
    0 0 0 1px rgba(255, 255, 255, 0.72) inset;
}

.page-header::before {
  content: "";
  position: absolute;
  top: -30%;
  right: -8%;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 122, 0, 0.18), transparent 70%);
  pointer-events: none;
}

.page-header-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.25rem;
}

.page-eyebrow {
  display: inline-flex;
  margin-bottom: 0.65rem;
  border-radius: 999px;
  padding: 0.32rem 0.7rem;
  color: #b45309;
  font-family: "XoloniumBold", sans-serif;
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: #fff0dc;
}

h1 {
  margin: 0;
  color: #111827;
  font-family: "XoloniumBold", sans-serif;
  font-size: clamp(1.85rem, 4vw, 3.1rem);
  line-height: 0.98;
  letter-spacing: -0.05em;
  font-size: xx-large;
}

p {
  max-width: 760px;
  margin: 0.85rem 0 0;
  color: #64748b;
  font-size: 0.92rem;
  line-height: 1.75;
}

.page-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

.page-metrics {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 1.25rem;
}

@media (max-width: 860px) {
  .page-header-content {
    align-items: stretch;
    flex-direction: column;
  }

  .page-actions {
    width: 100%;
  }

  .page-metrics {
    grid-template-columns: 1fr;
  }
}
</style>
